module.exports = __webpack_public_path__ + "9042a37caa7fb0389371de54dd886b38.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/BebasNeue-Regular.ttf
// module id = 366
// module chunks = 1